module.exports = __webpack_public_path__ + "static/logoIcon-64c654dabb307a634096e49ad79f3194.png";